import React from 'react';

const Header = ({ text }) => (
  <header className="container-fluid p-4">
    <h1 className="display-2 text-center">{text}</h1>
  </header>
);

export default Header;